export const CROSS_DOCK_DELIVERY_TYPE = 'CROSS DOCK';

export const FREIGHT_TYPE_OPTIONS = [
    { value: 'FTL', label: 'FTL' },
    { value: 'LTL', label: 'LTL' },
    { value: 'Rail', label: 'Rail' },
];

export const DEFAULT_CROSS_DOCK_PURCHASE_ORDER_DRAFT = {
    crossDockId: '',
    facilityId: '',
    freightType: '',
    dockDoor: '',
    scheduledDeliveryDate: '',
    scheduledDeliveryTime: '',
    shipDate: '',
    minTemp: '',
    maxTemp: '',
    specialInstructions: '',
};

/**
 * Placeholder SERVICE_FEE row until BIZ-10215 additional-fees UI ships.
 * API requires a non-empty additionalFees array with SERVICE_FEE.
 */
export function buildPlaceholderServiceFeeRow() {
    return {
        chargeType: 'SERVICE_FEE',
        quantity: 1,
        unitRate: 0,
        totalRate: 0,
    };
}

function parseOptionalInt(value) {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const normalized = String(value).trim();
    if (!/^-?\d+$/.test(normalized)) {
        return null;
    }
    const parsed = Number.parseInt(normalized, 10);
    return Number.isFinite(parsed) ? parsed : null;
}

function buildCreateRequestBody(draft, { crossDockId, facilityId, maxTemp, minTemp }) {
    const body = {
        deliveryType: CROSS_DOCK_DELIVERY_TYPE,
        crossDockId,
        facilityId,
        freightType: draft.freightType,
        additionalFees: [buildPlaceholderServiceFeeRow()],
        poMaps: [],
    };

    const dockDoor = String(draft.dockDoor ?? '').trim();
    if (dockDoor) {
        body.dockDoor = dockDoor;
    }

    if (draft.scheduledDeliveryDate) {
        body.scheduledDeliveryDate = draft.scheduledDeliveryDate;
    }
    if (draft.scheduledDeliveryTime) {
        body.scheduledDeliveryTime = draft.scheduledDeliveryTime;
    }
    if (draft.shipDate) {
        body.shipDate = draft.shipDate;
    }
    if (minTemp !== null) {
        body.minTemp = minTemp;
    }
    if (maxTemp !== null) {
        body.maxTemp = maxTemp;
    }

    const specialInstructions = String(draft.specialInstructions ?? '').trim();
    if (specialInstructions) {
        body.specialInstructions = specialInstructions;
    }

    return body;
}

/**
 * @param {typeof DEFAULT_CROSS_DOCK_PURCHASE_ORDER_DRAFT} draft
 */
export function validateCrossDockPurchaseOrderCreate(draft) {
    const primaryFieldErrors = {};
    const primaryErrors = [];

    const crossDockId = Number(draft.crossDockId);
    if (!Number.isFinite(crossDockId) || crossDockId <= 0) {
        primaryFieldErrors.crossDockId = 'Destination cross dock is required';
        primaryErrors.push('Destination cross dock is required');
    }

    const facilityId = Number(draft.facilityId);
    if (!Number.isFinite(facilityId) || facilityId <= 0) {
        primaryFieldErrors.facilityId = 'Facility is required';
        primaryErrors.push('Facility is required');
    }

    if (!draft.freightType) {
        primaryFieldErrors.freightType = 'Freight type is required';
        primaryErrors.push('Freight type is required');
    }

    const minTemp = parseOptionalInt(draft.minTemp);
    const maxTemp = parseOptionalInt(draft.maxTemp);
    if (draft.minTemp !== '' && minTemp === null) {
        primaryFieldErrors.minTemp = 'Min temperature must be a whole number';
        primaryErrors.push('Min temperature must be a whole number');
    }
    if (draft.maxTemp !== '' && maxTemp === null) {
        primaryFieldErrors.maxTemp = 'Max temperature must be a whole number';
        primaryErrors.push('Max temperature must be a whole number');
    }
    if (minTemp !== null && maxTemp !== null && minTemp > maxTemp) {
        primaryFieldErrors.maxTemp = 'Max temperature must be greater than or equal to min';
        primaryErrors.push('Max temperature must be greater than or equal to min');
    }

    const isValid = primaryErrors.length === 0;

    return {
        isValid,
        primaryErrors,
        primaryFieldErrors,
        submitBody: isValid ? buildCreateRequestBody(draft, { crossDockId, facilityId, maxTemp, minTemp }) : null,
    };
}
